export default __webpack_public_path__ + "static/media/heart-white.01be48cc.png";